var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.634 2.366a1.25 1.25 0 0 0-1.304-.293l-17.5 6.25a1.248 1.248 0 0 0-.828 1.1c-.03.5.24.969.689 1.194l5.732 2.865L15.75 8.25l-5.233 7.327 2.865 5.733a1.254 1.254 0 0 0 1.118.69 1.25 1.25 0 0 0 1.179-.83l6.25-17.5a1.253 1.253 0 0 0-.295-1.304Z"
  })));
};

export default SvgSend;